import React from 'react';
import { Box, IconButton } from '@mui/material';
import { useDispatch } from 'react-redux';
import { GridToolbarContainer, GridToolbarFilterButton } from '@mui/x-data-grid';
import RefreshIcon from '@mui/icons-material/Refresh';
import DataGridColumnReorderButton from '@/components/table/DataGridComponents/DataGridColumnReorderButton';
import { triggerRefresh } from '@/features/table/attachmentsTableSlice';

export const AttachmentsToolbar = () => {
	const dispatch = useDispatch();

	return (
		<GridToolbarContainer>
			<DataGridColumnReorderButton />
			<GridToolbarFilterButton />
			<Box sx={{ flexGrow: 1 }} />
			<IconButton size='small' onClick={() => dispatch(triggerRefresh())}>
				<RefreshIcon
					sx={(theme) => ({ fontSize: '1.25rem', color: theme.palette.primary.main })}
				/>
			</IconButton>
		</GridToolbarContainer>
	);
};
